module.exports = __webpack_public_path__ + "img/35.a5fdbc25.png";